import { render, staticRenderFns } from "./JciProgramPlansListDialog.vue?vue&type=template&id=0b72e30d&scoped=true"
import script from "./JciProgramPlansListDialog.vue?vue&type=script&lang=js"
export * from "./JciProgramPlansListDialog.vue?vue&type=script&lang=js"
import style0 from "./JciProgramPlansListDialog.vue?vue&type=style&index=0&id=0b72e30d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b72e30d",
  null
  
)

export default component.exports